import gql from 'graphql-tag';

const GET_ALL_ORDERS = gql`
  query data {
    orders (first: 100) {
      edges {
        node {
          id,
          name,
          displayFulfillmentStatus,
          createdAt
        }
      }
    }
  }
`;

export default GET_ALL_ORDERS;
